import { is, List } from "immutable";
import * as React from "react";
import { connect } from "react-redux";
import * as redux from "redux";
import * as Actions from "../../../actions/";
import * as Comp from "../../../components";
import * as M from "../../../models";
import { AppState } from "../../../store";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
    types: state.adminAbstracts.types,
    loading: state.adminAbstracts.loadingTypes,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
    loadData: (eventId: number) => dispatch(Actions.AdminAbstract.loadTypes(eventId)),
    toggleLoading: (loading: boolean) => dispatch(Actions.AdminAbstract.toggleLoadingTypes(loading)),
});

interface OwnProps {
    eventId: number;
    onUpdated: (loading: boolean, types: List<M.Abstract.AbstractType>) => void;
}

type ConnectedState = Comp.Base.DefaultConnectedState & {
    types: List<M.Abstract.AbstractType>;
    loading: boolean;
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
    loadData: (eventId: number) => void;
    toggleLoading: (loading: boolean) => void;
};

interface OwnState {
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class LoaderComponent extends React.Component<CombinedProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public componentDidMount() {
        this.loadDataFromStore(true);
    }

    public componentDidUpdate(prevProps: Readonly<CombinedProps>) {
        if (!is(prevProps.types, this.props.types))
            this.loadDataFromStore();
        if (!is(prevProps.loading, this.props.loading))
            this.loadDataFromStore();
    }

    public render() {
        return null;
    }

    private loadDataFromStore(isInitialCheck: boolean = false) {
        const types = this.props.types
            .filter((x) => x !== undefined && x.eventId === this.props.eventId)
            .toList();

        this.props.onUpdated(this.props.loading, types);

        if (isInitialCheck) {
            this.props.loadData(this.props.eventId);
            if (!types.size)
                this.props.toggleLoading(true);
        }
    }
}

export const AdminAbstractTypesLoader: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(LoaderComponent);



// WEBPACK FOOTER //
// ./src/containers/abstracts/components/AdminAbstractTypesLoader.tsx